export var SceneNames;
(function (SceneNames) {
    SceneNames["Stables"] = "Stables";
    SceneNames["SkinTest"] = "SkinTest";
})(SceneNames || (SceneNames = {}));
export const SceneNamesToFileName = new Map([
    [SceneNames.Stables, 'stable_optimized'],
    [SceneNames.SkinTest, 'fullassettesting']
]);
